import { createContext } from 'react';

/**
 * Injects a chat controller into <ChatDrawer/> from above. The demo route sets this
 * to a useDemoChat() controller; in production it stays null and ChatDrawer uses the
 * real useChat() (so prod chat — and its tests — are unaffected). This lets the demo
 * reuse the existing views' chat rendering without editing their JSX.
 */
export const ChatControllerContext = createContext(null);
